// src/components/common/Tabs.jsx
import React from 'react';

const Tabs = ({ tabs, activeTab, onTabChange }) => {
  const styles = {
    container: {
      borderBottom: '1px solid #e5e7eb',
      backgroundColor: '#ffffff',
    },
    tabList: {
      display: 'flex',
      gap: '0.5rem',
      padding: '0 1.5rem',
      margin: 0,
      listStyle: 'none',
      overflowX: 'auto',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      WebkitOverflowScrolling: 'touch',
    },
    tabItem: {
      flex: '0 0 auto',
    },
    tabButton: {
      padding: '1rem 1rem',
      background: 'none',
      border: 'none',
      borderBottom: '2px solid transparent',
      fontSize: '0.875rem',
      fontWeight: 500,
      color: '#6b7280',
      cursor: 'pointer',
      transition: 'all 0.2s',
      whiteSpace: 'nowrap',
    },
    tabButtonActive: {
      color: '#2563eb',
      borderBottomColor: '#2563eb',
    },
    tabButtonHover: {
      color: '#111827',
    },
    badge: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: '0.5rem',
      padding: '0.125rem 0.5rem',
      fontSize: '0.75rem',
      fontWeight: 500,
      backgroundColor: '#f3f4f6',
      color: '#6b7280',
      borderRadius: '9999px',
      transition: 'all 0.2s',
    },
    badgeActive: {
      backgroundColor: '#dbeafe',
      color: '#2563eb',
    },
  };

  const handleTabClick = (tabId) => {
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  return (
    <div style={styles.container}>
      <ul style={styles.tabList}>
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          
          // Extract count from label if present
          let label = tab.label;
          let count = null;
          
          if (typeof tab.label === 'string') {
            const match = tab.label.match(/^(.*?)\s*\((\d+)\)$/);
            if (match) {
              label = match[1];
              count = parseInt(match[2], 10);
            }
          }

          return (
            <li key={tab.id} style={styles.tabItem}>
              <button
                onClick={() => handleTabClick(tab.id)}
                style={{
                  ...styles.tabButton,
                  ...(isActive ? styles.tabButtonActive : {}),
                }}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.color = styles.tabButtonHover.color;
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.color = styles.tabButton.color;
                  }
                }}
              >
                {label}
                {count !== null && (
                  <span
                    style={{
                      ...styles.badge,
                      ...(isActive ? styles.badgeActive : {}),
                    }}
                  >
                    {count}
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Tabs;